import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { OAuthRouteClassifierService } from '@app/core/services/oauth-route-classifier.service';

@Injectable({
    providedIn: 'root',
})
export class BypassRecaptchaInterceptor implements HttpInterceptor {
    public constructor(private routeClassifier: OAuthRouteClassifierService) {}

    public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (
            !(
                this.routeClassifier.isTokenEndpoint(request.url) &&
                request.body?.updates?.[4] &&
                (environment.env === 'develop' || environment.env === 'staging')
            )
        ) {
            return next.handle(request);
        }

        const modifiedBody: URLSearchParams = new URLSearchParams();
        modifiedBody.set('grant_type', 'undefined');
        modifiedBody.set('username', request.body.updates[3].value);
        modifiedBody.set('password', request.body.updates[4].value);

        const modifiedReq: HttpRequest<any> = request.clone({
            setHeaders: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: modifiedBody.toString(),
        });

        return next.handle(modifiedReq);
    }
}
